import { mergeMap } from '../common/rxjs/operators';
export function actionMergeMap(action, mergeF) {
  return $action => $action.ofType(action).pipe(mergeMap(mergeF));
}